import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { BlogApiData } from "../index";

interface SnapshotSectionProps {
  formData: BlogApiData;
  onSectionChange: (section: keyof BlogApiData["al_sections"], field: string, value: string) => void;
  quillModules: any;
  quillFormats: string[];
}

const SnapshotSection: React.FC<SnapshotSectionProps> = ({
  formData,
  onSectionChange,
  quillModules,
  quillFormats,
}) => {
  return (
    <>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Section Title
        </label>
        <input
          type="text"
          value={formData.al_sections.snapshotSection.title}
          onChange={(e) =>
            onSectionChange(
              "snapshotSection",
              "title",
              e.target.value
            )
          }
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="e.g., Tirana at a Glance"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Section Description
        </label>
        <ReactQuill
          theme="snow"
          value={formData.al_sections.snapshotSection.description}
          onChange={(value) =>
            onSectionChange(
              "snapshotSection",
              "description",
              value
            )
          }
          modules={quillModules}
          formats={quillFormats}
          placeholder="e.g., Get a quick overview of what makes Tirana unique"
        />
      </div>
    </>
  );
};

export default SnapshotSection;
